"use client";

import { useContext } from "react";

import { MantineContext, MantineProvider } from "@mantine/core";

import { theme } from "@/theme";

/**
 * Supplies Mantine's provider only when the tree above has none.
 *
 * Next renders the root `not-found.tsx` without the root layout on some paths:
 * a server-action request that resolves to not-found is rendered through a loader
 * tree that holds the not-found page and nothing else. Every Mantine component
 * reads the theme from context, so a fallback page mounted that way throws
 * instead of rendering. Wrapping the page in this makes it stand alone there
 * and leaves the normal path untouched: with a provider already above, this
 * renders its children unchanged rather than nesting a second provider.
 */
export function StandaloneMantineProvider({ children }: { children: React.ReactNode }) {
  const hasProvider = useContext(MantineContext) !== null;

  if (hasProvider) {
    return <>{children}</>;
  }

  return <MantineProvider theme={theme}>{children}</MantineProvider>;
}
